import React from 'react';
import { components } from 'react-select';

const AutcompleteMenuList = (props) => {
    const { ...elementProps } = props;

    return (
        <components.MenuList className="autocomplete-section rounded box-shadow" {...elementProps}>{props.children}</components.MenuList>
    );
};

export default AutcompleteMenuList;
